import { useAppSelector } from "../../../../store";

export const DEFAULT_MAX_UI_KPIS = 8;

export const useMaxUiKpis = (): number =>
  useAppSelector((state) => state.boot.configuration?.actionReports?.maxUiKpis) ?? DEFAULT_MAX_UI_KPIS;
